<template>
  <div class="margin-top">
    <div class="label-input">
      {{ $t('agronomySample.summary.samplingDate') }}
    </div>
    <div class="recepDate marginTop5">
      <f7-input
        class="shadow"
        type="datepicker"
        :placeholder="$t('agronomySample.chooseDates')"
        :clear-button="true"
        :close-on-select="true"
        :value="calculatedAgronomySamplingDate"
        :calendar-params="{
          closeOnSelect: true,
          rangePicker: true,
          dateFormat: {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
          },
          disabled: isDisabled,
        }"
        @calendar:change="setSamplingDate"
      />
    </div>

    <div class="margin-top">
      <div class="label-input">
        {{ $t('agronomySample.summary.sampleType') }}
      </div>

      <DxTagBox
        :data-source="sampleTypes"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('agronomySample.summary.sampleType')"
        tag-template="tag"
        :value="selectedSampleTypes"
        display-expr="value"
        value-expr="id"
        :on-value-changed="sampleTypesChanged"
        :on-opened="openedSampleTypes"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data.value }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>
    <div class="margin-top">
      <div class="label-input">
        {{ $t('agronomySample.summary.estate') }}
      </div>

      <DxTagBox
        :data-source="farms"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('agronomySample.summary.estate')"
        tag-template="tag"
        :value="selectedFarms"
        display-expr="value"
        value-expr="value"
        :on-value-changed="farmsChanged"
        :on-opened="openedFarms"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data.value }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>
    <div class="margin-top">
      <div class="label-input">
        {{ $t('agronomySample.summary.parcel') }}
      </div>

      <DxTagBox
        :data-source="parcels"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('agronomySample.summary.parcel')"
        tag-template="tag"
        :value="selectedParcels"
        display-expr="value"
        value-expr="value"
        :on-value-changed="parcelsChanged"
        :on-opened="openedParcels"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data.value }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>
    <!--<div class="margin-top">
      <div class="label-input">{{ $t('agronomySample.summary.service') }}</div>

      <DxTagBox
        :data-source="services"
        :multiline="true"
        :placeholder="$t('agronomySample.summary.service')"
        tag-template="tag"
        :value="selectedServices"
        :on-value-changed="servicesChanged"
        :on-opened="openedServices"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>-->
    <div class="margin-top">
      <div class="label-input">
        {{ $t('agronomySample.cultive') }}
      </div>

      <DxTagBox
        :data-source="cultives"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('agronomySample.cultive')"
        tag-template="tag"
        :value="selectedCultives"
        display-expr="value"
        value-expr="id"
        :on-value-changed="cultivesChanged"
        :on-opened="openedCultives"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data.value }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>
    <div class="margin-top">
      <div class="label-input">{{ $t('project') }}</div>

      <DxTagBox
        :data-source="studies"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('project')"
        tag-template="tag"
        :value="selectedStudies"
        display-expr="value"
        value-expr="value"
        :on-value-changed="studiesChanged"
        :on-opened="openedStudies"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data.value }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>

    <div class="margin-top">
      <div class="label-input">
        {{ $t('foodSamples.analysisType') }}
      </div>
      <DxTagBox
        :data-source="analyseTypes"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('foodSamples.analysisType')"
        tag-template="tag"
        :value="selectedAnalyseTypes"
        display-expr="value"
        value-expr="value"
        :on-value-changed="analyseTypesChanged"
        :on-opened="openedAnalyseTypes"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data.value }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>
    <div class="margin-top">
      <div class="label-input">
        {{ $t('agronomySample.summary.status') }}
      </div>

      <DxTagBox
        :data-source="statuses"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('agronomySample.summary.status')"
        tag-template="tag"
        :value="selectedStatuses"
        display-expr="value"
        value-expr="id"
        :on-content-ready="contentReady"
        :on-opened="openedStatuses"
        :on-value-changed="statusesChanged"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data.value }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>
    <div class="margin-top">
      <div class="label-input">{{ $t('agronomySample.summary.monitoring') }}</div>
      <div class="purpleTag-checkBox">
        <DxCheckBox
          :value="selectedMonitoring"
          @option-changed="monitoringChanged"
        >
        </DxCheckBox>
      </div>
    </div>
    <!--<div class="margin-top">
      <div class="label-input">{{ $t('agronomySample.summary.client') }}</div>

      <DxTagBox
        :data-source="clients"
        :multiline="true"
        :placeholder="$t('agronomySample.summary.client')"
        tag-template="tag"
        :value="selectedClients"
        :on-value-changed="clientsChanged"
        :on-opened="openedClients"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>-->
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { DxTagBox } from 'devextreme-vue/tag-box';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DataSource from 'devextreme/data/data_source';
import moment from 'moment';
import { AFTER_DATE_LIMIT } from '@/js/constants';

export default {
  components: { DxTagBox, DxCheckBox },
  data() {
    return {
      sampleTypes: [],
      farms: [],
      parcels: [],
      services: [],
      cultives: [],
      studies: [],
      clients: [],
      analyseTypes: [],
      statuses: [],
      loaded: false,
      monitoring: false,
    };
  },
  computed: {
    calculatedAgronomySamplingDate() {
      if (
        this.samplingToDate !== null &&
        this.samplingFromDate !== null
      ) {
        return [this.samplingFromDate, this.samplingToDate];
      }
      return [];
    },
    ...mapState('agronomySamples', ['allSamples']),
    ...mapState('agronomyFilter', [
      'selectedSampleTypes',
      'samplingFromDate',
      'samplingToDate',
      'selectedFarms',
      'selectedParcels',
      'selectedServices',
      'selectedCultives',
      'selectedClients',
      'selectedStudies',
      'selectedAnalyseTypes',
      'selectedStatuses',
      'selectedMonitoring',
    ]),
  },
  methods: {
    isDisabled(date) {
      return (
        moment(date).isBefore(moment(AFTER_DATE_LIMIT), 'day') ||
        moment(date).isAfter(moment(), 'day')
      );
    },
    async openedSampleTypes(e) {
      const sampleTypes = await this.getSampleFilter({
        atc: 'Agronomía',
        attribute: 'sample_type',
      });

      this.sampleTypes = new DataSource({
        store: sampleTypes,
        key: '',
        paginate: true,
        pageSize: 10,
      });
      this.loaded = true;
    },
    analyseTypesChanged(e) {
      this.setSelectedAnalyseTypes(e.value);
    },
    async openedFarms(e) {
      const farms = await this.getSampleFilter({
        atc: 'Agronomía',
        attribute: 'farm',
      });

      this.farms = new DataSource({
        store: farms,
        key: '',
        paginate: true,
        pageSize: 10,
      });
      this.loaded = true;
    },
    async openedParcels(e) {
      const parcels = await this.getSampleFilter({
        atc: 'Agronomía',
        attribute: 'parcel',
      });

      this.parcels = new DataSource({
        store: parcels,
        key: '',
        paginate: true,
        pageSize: 10,
      });
      this.loaded = true;
    },
    async openedAnalyseTypes(e) {
      const analyseTypes = await this.getSampleFilter({
        atc: 'Agronomía',
        attribute: 'analyse_type',
      });

      this.analyseTypes = new DataSource({
        store: analyseTypes,
        key: '',
        paginate: true,
        pageSize: 10,
      });
      this.loaded = true;
    },
    async openedServices(e) {
      const services = await this.getSampleFilter({
        atc: 'Agronomía',
        attribute: 'type_service_code',
      });

      this.services = services.sort();
      this.loaded = true;
    },
    async openedStatuses(e) {
      const statuses = await this.getSampleFilter({
        atc: 'Agronomía',
        attribute: 'status',
      });

      this.statuses = statuses.sort();
      this.loaded = true;
    },
    async openedCultives(e) {
      const cultives = await this.getSampleFilter({
        atc: 'Agronomía',
        attribute: 'cultive',
      });

      this.cultives = cultives.sort();
      this.loaded = true;
    },
    async openedClients(e) {
      const clients = await this.getSampleFilter({
        atc: 'Agronomía',
        attribute: 'company',
      });

      this.clients = clients.sort();
      this.loaded = true;
    },
    async openedStudies(e) {
      const studies = await this.getStudySatellite();
      this.studies = new DataSource({
        store: studies,
        key: '',
        paginate: true,
        pageSize: 10,
      });
      this.loaded = true;
    },
    contentReady(e) {
      const arrayNotFoundItems = Array.from(
        document.getElementsByClassName('dx-empty-message')
      );

      arrayNotFoundItems.forEach((element) => {
        if (!this.loaded) {
          element.innerHTML = this.$t('loading');
        } else {
          element.innerHTML = this.$t('dataNotAvailable');
        }
      });

      this.loaded = false;
    },
    setSamplingDate(e) {
      if (e.length === 2) {
        this.setSamplingFromDate(e[0]);
        this.setSamplingToDate(e[1]);
      } else if (e.length === 0) {
        this.setSamplingFromDate(null);
        this.setSamplingToDate(null);
      }
    },
    farmsChanged(e) {
      this.setSelectedFarms(e.value);
    },
    cultivesChanged(e) {
      this.setSelectedCultives(e.value);
    },
    servicesChanged(e) {
      this.setSelectedServices(e.value);
    },
    parcelsChanged(e) {
      this.setSelectedParcels(e.value);
    },
    sampleTypesChanged(e) {
      this.setSelectedSampleTypes(e.value);
    },
    clientsChanged(e) {
      this.setSelectedClients(e.value);
    },
    statusesChanged(e) {
      this.setSelectedStatuses(e.value);
    },
    studiesChanged(e) {
      this.setSelectedStudies(e.value);
    },
    monitoringChanged(e) {
      this.setSelectedMonitoring(e.value);
    },
    ...mapActions('agronomyFilter', [
      'setSelectedSampleTypes',
      'setSamplingFromDate',
      'setSamplingToDate',
      'setSelectedFarms',
      'setSelectedCultives',
      'setSelectedServices',
      'setSelectedParcels',
      'setSelectedClients',
      'setSelectedStudies',
      'setSelectedAnalyseTypes',
      'setSelectedStatuses',
      'setSelectedMonitoring',
    ]),
    ...mapActions('samples', ['getSampleFilter']),
    ...mapActions('agronomySamples', ['getStudySatellite']),
  },
};
</script>
